import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import config from '../config';
import {
  Form,
  DatePicker,
  Radio,
  InputNumber,
  Input
} from 'antd';
import moment from 'moment';
import { toTitleCase, todaysDate } from './utils';
import { user } from '../lib/authLib';
import LoaderButton from "../components/LoaderButton";
import './AddAStudentForm.scss';

export default function AddAStudentForm({
  classUuid,
  setClassAttendees,
  setDisplayAddStudentForm
}) {
  const [showSwirlyAndDisableSubmitBtn, setShowSwirlyAndDisableSubmitBtn] = useState(false);
  const [ form ] = Form.useForm();
  const americanDatePickerFormat = 'MM/DD/YYYY';
  const defaultInitialValues = {
    name: '',
    email: '',
    dateAdded: moment(todaysDate(), americanDatePickerFormat),
    price: '',
    paymentStatus: 'paid',
    position: 'lead',
    notes: ''
  };

  async function onFinish(values) {
    setShowSwirlyAndDisableSubmitBtn(true);
    const currentUserSession = await Auth.currentSession();

    try {
      const newAttendeesList = await window.fetch(`${config.serverUrl}classes/add_student/${classUuid}/${user[0].email}`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'accesstoken': currentUserSession.getAccessToken().getJwtToken(),
        },
        body: JSON.stringify({
          ...values,
          amountPaid: values.price.toString(),
          dateAdded: values.dateAdded.format(americanDatePickerFormat)
        }),
      });

      setClassAttendees(await newAttendeesList.json());
      setDisplayAddStudentForm(0);
    } catch (err) {
      console.error(err);
    } finally {
      setShowSwirlyAndDisableSubmitBtn(false);
      form.setFieldsValue(defaultInitialValues); // resets the form to initial state
    }
  };

  function onFinishFailed(errorInfo) {
    console.error('\nFailed:\n', errorInfo);
  };

  function radioSelectOption(position, i) {
    return (
      <Radio value={position} key={`${position}-${i+1}`}>
        {toTitleCase(position)}
      </Radio>
    );
  }

  return (
    <Form
      form={form}
      name="basic"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
      initialValues={defaultInitialValues}
      className="AddAStudentForm"
    >
    <Form.Item
      label="Name: "
      name="name"
      rules={[
        {
          required: true,
          message: 'Please input the student\'s name',
        },
      ]}
    >
      <Input placeholder="Name" />
    </Form.Item>

    <Form.Item
      label="Email: "
      name="email"
      rules={[
        {
          required: true,
          message: 'Please input the student\'s name',
        },
      ]}
    >
      <Input placeholder="Email" />
    </Form.Item>

    <Form.Item
      label="Date: "
      name="dateAdded"
      rules={[
        {
          required: true,
          message: 'Please input the student\'s name',
        },
      ]}
    >
      <DatePicker
        dropdownClassName="clickable-dropdown-for-picker"
        format={new Array(2).fill(americanDatePickerFormat)} />
    </Form.Item>

    <Form.Item
      label="Price: "
      name="price"
      rules={[
        {
          required: true,
          message: 'Please Input a price',
        },
      ]}
    >
      <InputNumber
        style={{ width: '130px' }}
        formatter={(val) => `$ ${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        parser={(val) => val.replace(/\$\s?|(,*)/g, '')}
      />
    </Form.Item>

    <Form.Item
      label="Position: "
      name="position"
      rules={[
        {
          required: true,
          message: 'Please choose a position',
        },
      ]}
    >
      <Radio.Group defaultValue='lead'>
        {
          [
            'lead',
            'follow',
            'either'
          ].map(radioSelectOption)
        }
      </Radio.Group>
    </Form.Item>

    <Form.Item
      label="Status: "
      name="paymentStatus"
    >
      <Radio.Group defaultValue='paid'>
        {
          [
            'paid',
            'unpaid',
            'waitlisted'
          ].map(radioSelectOption)
        }
      </Radio.Group>
    </Form.Item>

    <Form.Item
      label="Notes: "
      name="notes"
    >
      <Input.TextArea />
    </Form.Item>

    <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
      <LoaderButton
        type="submit"
        variant="primary"
        isLoading={showSwirlyAndDisableSubmitBtn}
        disabled={showSwirlyAndDisableSubmitBtn}
      >
        Add Student
      </LoaderButton>
    </Form.Item>

  </Form>
  );
}
